var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"get"},[_c('AvatarIconSet',{attrs:{"size":180,"iconSet":[{ image: _vm.tokenImage }]}}),_c('div',{staticClass:"get-description description",domProps:{"innerHTML":_vm._s(_vm.$t('trade.btc.description'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }